import { createSelector } from "reselect";
import getFirebaseUser from "./get_firebase_user";

const getFirebaseIdToken = createSelector([
  getFirebaseUser
], (firebaseUser) => firebaseUser?.idToken || null);

export default getFirebaseIdToken;
